import z from 'zod';
import { optionSchema } from '~/features/types';
import { nonNegativeInt, positiveNumber } from '~/features/utils';

export const OnCallShiftDetailsFormSchema = z.object({
  id: z.number().optional(),
  jobListingId: z.number().optional(),
  // Shift Allocation
  numDayCallShifts: nonNegativeInt,
  numEveCallShifts: nonNegativeInt,
  numNightCallShifts: nonNegativeInt,
  numOfWeDayCallShifts: nonNegativeInt,
  numOfWeEveCallShifts: nonNegativeInt,
  numOfWeNightCallShifts: nonNegativeInt,
  numHolDayCallShifts: nonNegativeInt,
  numHolEveCallShifts: nonNegativeInt,
  numHolNightCallShifts: nonNegativeInt,
  // Shift Differentials
  callShiftDiffType: optionSchema,
  dayCallShiftRateDiff: positiveNumber,
  eveCallShiftRateDiff: positiveNumber,
  nightCallShiftRateDiff: positiveNumber,
  weDayCallShiftRateDiff: positiveNumber,
  weEveCallShiftRateDiff: positiveNumber,
  weNightCallShiftRateDiff: positiveNumber,
  holDayCallShiftRateDiff: positiveNumber,
  holEveCallShiftRateDiff: positiveNumber,
  holNightCallShiftRateDiff: positiveNumber,
});

export type OnCallShiftDetailsFormValues = z.infer<typeof OnCallShiftDetailsFormSchema>;
